<template>
  <div class="card">
    <div class="card-header">
      <h3>Edit Profile</h3>
    </div>
    <div class="card-body">
      <form ref="profile_form" @submit.prevent="handleProfileUpdate">
        <!-- <div class="form-group">
          <label> Profile Photo </label>
          <div v-if="image" class="profile-image pb-4">
            <img :src="`${image}`" class="profile-image now-ui-image" />
          </div>
          <div v-else class="profile-image">
            <img src="/img/placeholder.jpg" class="now-ui-image" />
          </div>
          <div>
            <n-button
              v-if="image"
              type="button"
              class="btn btn-sm btn-danger mr-2"
              @click.native="removeImage"
            >
              <span>
                <i class="fa fa-times" />
                Remove
              </span>
            </n-button>

            <input
              id="imageInput"
              ref="imageInput"
              accept="image/*"
              type="file"
              style="display: none"
              @input="onFileChange"
            />

            <n-button
              type="button"
              class="btn btn-sm btn-primary"
              @click.native="onClickFile"
            >
              <label
                v-if="!image"
                class="mb-0"
                style="color: white; cursor: pointer"
                >Select image</label
              >
              <label v-else class="mb-0" style="color: white; cursor: pointer"
                >Change</label
              >
            </n-button>
          </div>
        </div>
        <validation-error :error="apiValidationErrors.attachment" /> -->
        <label>Name</label>
        <fg-input
          prepend-icon="fas fa-user"
          placeholder="Your name"
          v-model="user.name"
          addon-left-icon="now-ui-icons users_circle-08"
          :error="apiValidationErrors.name"
        />
        <label>Email</label>
        <fg-input
          prepend-icon="fas fa-envelope"
          placeholder="Email"
          v-model="user.email"
          addon-left-icon="now-ui-icons ui-1_email-85"
          :error="apiValidationErrors.email"
        />
        <p><br></p>
        <v-row align="center">
          <p><br><br></p>
          <v-divider></v-divider>Shopware API Account<v-divider></v-divider>
        </v-row>
        <label>User</label>
        <fg-input
          prepend-icon="fas fa-envelope"
          placeholder="SW User"
          v-model="user.sw_user"
          addon-left-icon="now-ui-icons users_single-02"
          :error="apiValidationErrors.sw_user"
        />
        <label>URL - <i>e.g. my-best-shop.com, without https://...</i></label>
        <fg-input
          prepend-icon="fas fa-envelope"
          placeholder="SW URL"
          v-model="user.sw_url"
          addon-left-icon="now-ui-icons media-2_sound-wave"
          :error="apiValidationErrors.sw_url"
        />
        <label>API Key</label>
        <fg-input
          required
          prepend-icon="fas fa-envelope"
          placeholder="SW API Key"
          v-model="user.sw_key"
          addon-left-icon="now-ui-icons objects_key-25"
          :error="apiValidationErrors.sw_key"
        />

        <div class="my-4">
          <n-button
            type="button"
            class="btn btn-sm btn-primary"
            native-type="submit"
          >
            Submit
          </n-button>
        </div>

        <label>vTool Settings (read only)</label>
        <!-- <fg-input
          prepend-icon="fas fa-code"
          placeholder="..."
          v-model="user.vtool_settings"
          :error="apiValidationErrors.vtool_settings"
        /> -->
        <pre  v-html="outputJsonPretty"> {{ outputJsonPretty }}</pre>
      </form>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "UserEditCard",
  components: {
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
      image: null,
      file: null,
      outputJsonPretty: '',
    };
  },

  created () {
    this.syntaxHighlight()
  },

  methods: {
    onClickFile() {
      this.$refs.imageInput.click();
      console.log('onClickFile', this.user)
    },

    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.image = null;
    },

    async handleProfileUpdate() {
      if (this.$isDemo == 1 && ["1", "2", "3"].includes(this.user.id)) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed to change data of default users."
        );
        return;
      }
      try {
        this.resetApiValidation();
        if (this.file) {
          await this.$store.dispatch("users/upload", {
            user: this.user,
            image: this.file,
          });
          this.user.profile_image = await this.$store.getters["users/url"];
        }

        await this.$store.dispatch("profile/update", this.user);

        await this.$store.dispatch(
          "alerts/success",
          "Profile updated successfully."
        );
        await this.$store.getters["profile/me"];
        this.$parent.getShopLogo();
      } catch (error) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(error.response.data.errors);
      }
      this.$parent.$refs.usercard.getApiVersion();
    },

    output(inp) {
        // document.body.appendChild(document.createElement('pre')).innerHTML = inp;
        this.outputJsonPretty = inp;
    },

    async syntaxHighlight() {

        // http://jsfiddle.net/KJQ9K/554/

        await this.$store.dispatch("profile/me");
        var user = await this.$store.getters["profile/me"];
        if(!user.vtool_settings)user.vtool_settings = '{}';
        var obj = JSON.parse(user.vtool_settings);
        //var obj = user.vtool_settings;
        var str = JSON.stringify(obj, undefined, 4);

        var json = str;

        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        this.outputJsonPretty = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            //this.outputJsonPretty = '<span class="' + cls + '">' + match + '</span>';
            return '<span class="' + cls + '">' + match + '</span>';
        });
    },

  },
};
</script>

<style>
  pre {
    outline: 1px solid #ccc;
    padding: 5px;
    margin: 5px;
    max-height: 250px;
    opacity: 0.2;
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
  }
  pre:hover {
    opacity: 0.9;
  }
  .string { color: green; }
  .number { color: darkorange; }
  .boolean { color: blue; }
  .null { color: magenta; }
  .key { color: red; }
  .form-control{
    height: auto !important;
  }
</style>
